import React, { Fragment, useState, useEffect } from "react";
import { styled } from '@mui/material/styles';
import { withRouter, useHistory } from "react-router-dom";
import Paper from "@mui/material/Paper";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

const PREFIX = 'Tabs';

const classes = {
  root: `${PREFIX}-root`,
  tabs: `${PREFIX}-tabs`,
  tab: `${PREFIX}-tab`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.root}`]: {
    background: "#0078a9",
    boxShadow: "none",
  },

  [`& .${classes.tabs}`]: {
    "& .MuiTabs-indicator": {
      color: "#fff",
    },
    "& .PrivateTabIndicator-colorSecondary": {
      color: "#fff",
    },
	"& .Mui-selected": {
      color: "#fff !important",
    },
  },

  [`& .${classes.tab}`]: {
    minWidth: 0,
    fontWeight: "bold",
    textTransform: "none",
    margin: "0 2vw",
    borderRadius: "4px",
    color: "#e9e9e9",
    outline: "none !important",
    opacity: 0.9,
    "& .MuiTab-wrapper": {
      color: "#fff",
    },
    "&:active": {
      outline: "none !important",
      border: "4px solid #2491ff !important",
    },
    "&:focus": {
      outline: "none !important",
    },
    "&:focus-visible": {
      border: "4px solid #2491ff !important",
    },
    "&:hover": {
      background: "#02719f !important",
    },
  }
}));

const TabsNav = ({ location: { pathname } }) => {
  const history = useHistory();
  // const [anchorEl, setAnchorEl] = useState(null);
  const [tabsValue, setTabsValue] = useState(
    window.location.pathname.split("/")[
      window.location.pathname.split("/").length - 1
    ]
  );

  const handleChange = (event, newValue) => {
    setTabsValue(newValue);
    history.push(`/${newValue}`);
  };



  const onKeyDown = (e) => {
    if (e.code === "Tab") {
      const currentId = parseInt(e.target.id.split("-")[1]);
      let focusId;
      if (e.shiftKey) {
        focusId = `tab-${currentId - 1}`;
      } else {
        focusId = `tab-${currentId + 1}`;
      }
      try {
        setTabsValue(document.getElementById(focusId).dataset.value);
      } catch (error) {
        setTabsValue(
          window.location.pathname.split("/")[
            window.location.pathname.split("/").length - 1
          ]
        );
      }
    }
  };

  useEffect(() => {
    setTabsValue(
      window.location.pathname.split("/")[
        window.location.pathname.split("/").length - 1
      ]
    );
  }, [history.location]);

  return (
    <Root>
      <Paper className={classes.root}>
        <Tabs indicatorColor="secondary" textColor="inherit"
          value={tabsValue}
          onChange={handleChange}
          onKeyDown={onKeyDown}
          centered
          className={classes.tabs}
          // selectionFollowsFocus={true}
          TabIndicatorProps={{
            style: {
              backgroundColor: "#fff",
            },
          }}
        >
          <Tab
            id="tab-1"
            label="About"
            aria-label="about page"
            value="about"
            data-value="about"
            className={classes.tab}
          />
          <Tab
            id="tab-2"
            label="Library"
            aria-label="library page"
            value="library"
            data-value="library"
            className={classes.tab}
          />
          <Tab
            id="tab-3"
            classes={{
              button: classes.button,
            }}
            label="Use Cases"
            aria-label="use cases page"
            className={classes.tab}
            value="usecases"
            data-value="usecases"
          />
          <Tab
            id="tab-4"
            classes={{
              button: classes.button,
            }}
            label="Help"
            aria-label="help page"
            className={classes.tab}
            value="help"
            data-value="help"
          />
        </Tabs>
      </Paper>
    </Root>
  );
};

export default withRouter(TabsNav);
